<template>
  <div class="prescription-container">
    <!-- Empty State -->
    <div v-if="data.length == 0" class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-prescription-bottle"></i>
      </div>
      <h3 class="empty-title">Nenhuma prescrição pendente!</h3>
    </div>

    <!-- Prescription Table -->
    <div v-if="data.length > 0" class="prescription-table-container">
      <v-data-table
        dense
        :headers="headers"
        :items="data"
        item-key="id"
        :footer-props="{
          'items-per-page-options': [10, 25, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
        class="modern-table"
        :no-data-text="'Nenhum registro encontrado'"
        :loading-text="'Carregando...'"
      >
        <template v-slot:[`item.resident_name`]="{ item }">
          {{ item.resident_name }}
        </template>
        <template v-slot:[`item.type`]="{ item }">
          {{ handleType(item.type) }}
        </template>
        <template v-slot:[`item.user_name`]="{ item }">
          {{ item.user_name }}
        </template>
        <template v-slot:[`item.period`]="{ item }">
          <div class="period-info">
            <div class="period-start">
              <span class="period-date">{{
                formatDate(item.start_date, false)
              }}</span>
            </div>
            <div class="period-separator">ATÉ</div>
            <div class="period-end">
              <span class="period-date">{{
                formatDate(item.end_date, false)
              }}</span>
            </div>
          </div>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <confirmation-dialog
            x_small
            certificate
            validate
            header-class=""
            message-title="VALIDAR PRESCRIÇÃO"
            message-body="Deseja realmente Validar essa evolução?"
            open-class="btn-modern btn-modern-save"
            open-left-icon="fas fa-signature"
            open-text="VALIDAR"
            @yes="validatePrescription(item.id)"
          />
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import ConfirmationDialog from "../../templates/Components/ConfirmationDialog";

import BRyHUB from "../../lib/BRy/hub";

import api from "../../services/api";

import { formatDate } from "../../lib/format";

import toast from "../../lib/ToastNotification";

export default {
  name: "TechnicalResponsibleMyValidationsPrescription",

  components: { ConfirmationDialog },

  props: {
    data: { type: Array },
    tableOptions: { type: [Array, Object] },
    total: { type: [Number, String] },
  },

  watch: {
    tableOptions: {
      handler() {
        this.options = this.tableOptions;
      },
    },

    options: {
      handler() {
        let { page, itemsPerPage } = this.options;

        this.$emit("paginate", { page, itemsPerPage });
      },
    },
  },

  data() {
    return {
      options: {},

      headers: [
        { text: "RESIDENTE", value: "resident_name", sortable: false },
        { text: "TIPO", value: "type", sortable: false },
        { text: "PRESCRITOR", value: "user_name", sortable: false },
        { text: "PERÍODO", value: "period", sortable: false },
        {
          text: "CADASTRADO",
          value: "created_at",
          sortable: false,
        },
        { text: "AÇÕES", value: "actions", sortable: false },
      ],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,

    handleType(type) {
      let types = {
        NORMAL: "NORMAL",
        LONGO_PRAZO: "LONGO PRAZO",
        default: "TIPO NÃO ENCONTRADO!",
      };

      return types[type] || types["default"];
    },

    getTypeClass(type) {
      return {
        "type-normal": type === "NORMAL",
        "type-long-term": type === "LONGO_PRAZO",
      };
    },

    async retrieve() {},

    async validatePrescription(id) {
      try {
        this.loading = true;

        let params = { id, table_name: "group_prescription_medicine" };

        let response = await api.put("/technical-responsible", params);

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");

          await BRyHUB.authorize({ id, table: "group_prescription_medicine" });

          this.$emit("paginate", { page: 1, itemsPerPage: 10 });
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.prescription-container {
  width: 100%;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  background: #f8fafc;
  border-radius: 8px;
  border: 2px dashed #e5e7eb;
}

.empty-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 16px;
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #9ca3af;
}

.empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.empty-text {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4;
}

/* Table Container */
.prescription-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.table-wrapper {
  overflow-x: auto;
}

/* Table Styles */
.prescription-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

/* Table Header */
.prescription-table thead {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
}

.prescription-table th {
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: #92400e;
  font-size: 12px;
  border-bottom: 2px solid #f59e0b;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.prescription-table th i {
  color: #d97706;
  font-size: 11px;
}

/* Column Widths */
.th-resident {
  width: 22%;
}
.th-type {
  width: 12%;
}
.th-prescriber {
  width: 18%;
}
.th-period {
  width: 25%;
}
.th-validated {
  width: 13%;
}
.th-actions {
  width: 10%;
}

/* Table Body */
.prescription-table tbody tr {
  transition: all 0.2s ease;
}

.prescription-table tbody tr:nth-child(even) {
  background-color: #fffbeb;
}

.prescription-table tbody tr:hover {
  background-color: #fef3c7;
  transform: scale(1.005);
}

.prescription-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: top;
}

/* Resident Cell */
.resident-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.resident-avatar {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  flex-shrink: 0;
}

.resident-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 13px;
  word-break: break-word;
}

/* Type Badge */
.type-badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  word-break: break-word;
}

.type-badge.type-normal {
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.type-badge.type-long-term {
  background: rgba(139, 92, 246, 0.1);
  color: #7c3aed;
  border: 1px solid rgba(139, 92, 246, 0.2);
}

/* Prescriber */
.prescriber-name {
  color: #374151;
  font-weight: 500;
  font-size: 12px;
  word-break: break-word;
}

/* Period Info */
.period-info {
  display: flex;
  align-items: center;
  gap: 4px;
}

.period-start,
.period-end {
  display: flex;
  align-items: center;
  gap: 4px;
}

.period-label {
  color: #d97706;
  font-weight: 600;
  font-size: 9px;
  text-transform: uppercase;
  min-width: 35px;
}

.period-date {
  color: #374151;
  font-size: 11px;
  font-weight: 500;
  background: rgba(245, 158, 11, 0.1);
  padding: 1px 4px;
  border-radius: 4px;
  border: 1px solid rgba(245, 158, 11, 0.2);
}

.period-separator {
  color: #d97706;
  font-size: 8px;
  text-align: center;
  margin: 2px 0;
}

/* Validated Date */
.validated-date {
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

/* Actions */
.td-actions {
  text-align: center;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .prescription-table {
    font-size: 12px;
  }

  .prescription-table th {
    padding: 8px 10px;
    font-size: 11px;
  }

  .prescription-table td {
    padding: 6px 10px;
  }

  .th-period {
    width: 28%;
  }
  .th-resident {
    width: 20%;
  }
  .th-prescriber {
    width: 16%;
  }
}

@media (max-width: 768px) {
  .prescription-table-container {
    border-radius: 6px;
  }

  .prescription-table {
    font-size: 11px;
  }

  .prescription-table th {
    padding: 6px 8px;
    font-size: 10px;
  }

  .prescription-table td {
    padding: 5px 8px;
  }

  .resident-avatar {
    width: 20px;
    height: 20px;
    font-size: 9px;
  }

  .resident-name {
    font-size: 12px;
  }

  .type-badge {
    font-size: 9px;
    padding: 1px 4px;
  }

  .prescriber-name {
    font-size: 11px;
  }

  .period-label {
    font-size: 8px;
    min-width: 30px;
  }

  .period-date {
    font-size: 10px;
  }

  .validated-date {
    font-size: 10px;
  }

  .period-separator {
    font-size: 7px;
  }
}

@media (max-width: 640px) {
  /* Stack table for mobile */
  .table-wrapper {
    overflow-x: scroll;
  }

  .prescription-table {
    min-width: 650px;
  }

  .th-period {
    width: 30%;
  }

  .th-resident {
    width: 25%;
  }

  .th-prescriber {
    width: 18%;
  }

  .th-type {
    width: 12%;
  }

  .th-validated {
    width: 10%;
  }

  .th-actions {
    width: 5%;
  }
}

/* Mobile Period Layout */
@media (max-width: 480px) {
  .period-info {
    gap: 2px;
  }

  .period-start,
  .period-end {
    gap: 2px;
  }

  .period-label {
    min-width: 25px;
    font-size: 7px;
  }

  .period-date {
    font-size: 9px;
    padding: 1px 2px;
  }

  .period-separator {
    margin: 1px 0;
  }
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.prescription-row {
  animation: fadeIn 0.3s ease-out;
}
</style>